export function ExpandIcon() {
  return (
    <svg width='15' height='9' viewBox='0 0 15 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13.5 7.0625L7.5 1.4375L1.5 7.0625' stroke='#F2C94C' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
